<template>
    <Button
        label="Inativar link"
        class="p-button-primary mr-2"
        icon="pi pi-minus-circle"
        @click="confirmarInativarLinkPagamento()"
        v-if="mostrarBtnInativar"
        aria-haspopup="true"
        aria-controls="overlay_menu"
    />
</template>

<script>
import services from './service';

export default {
    data() {
        return {};
    },
    emits: ['obterCheckout'],

    methods: {
        toggle(event) {
            this.$refs.menu.toggle(event);
        },
        confirmarInativarLinkPagamento() {
            this.$confirm.require({
                message: `Tem certeza que deseja inativar o link de pagamento?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.inativarLinkPagamento();
                },
            });
        },
        inativarLinkPagamento() {
            this.$store.dispatch('addRequest');
            const linkPagamentoId = this.$route.params.id;
            services.inativarLinkPagamento(linkPagamentoId).then((response) => {
                if (response?.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Link inativado',
                        detail: 'O link de pagamento foi inativado com sucesso',
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Link inativado',
                        detail: 'Não foi possível inativar o link de pagamento!',
                        life: 3000,
                    });
                }
                this.$emit('obterCheckout');
                this.$store.dispatch('removeRequest');
            });
        },
    },

    computed: {
        mostrarBtnInativar() {
            return this.$temAcessoView('CHECKOUTS-PAGAMENTOS-07');
        },
    },
};
</script>
